// extracted by mini-css-extract-plugin
export default {"project":"Projects_project__N2NIf","about":"Projects_about__L7bI9","more":"Projects_more__I8vXh","line":"Projects_line__+kHji","animate-gradient":"Projects_animate-gradient__NUetH"};